import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";
import Moment from "react-moment";

import { aircraftCategoryTranslated } from "../components/aircraft-register/textUtils.js";

const icons = [
  "type_aircraft",
  "type_helicopter",
  "type_balloon",
  "type_glider",
  "type_drone",
];

const AircraftRegistrationCard = (props) => {
  const [expanded, setExpanded] = useState(false);

  let listURL = document.location;
  listURL = listURL.origin + listURL.pathname;

  if (document.location.search) {
    let search = document.location.search;
    let pos = search.indexOf("search=");
    if (pos > -1) {
      let searchParams = search.substring(pos);
      listURL += "?" + searchParams;
    }
  }

  let type = 0;

  if (props.aircraftModelCategory.includes("Helikopter")) type = 1;
  else if (props.aircraftModelCategory.includes("Ballong")) type = 2;
  else if (props.aircraftModelCategory.includes("Seilfly")) type = 3;

  return (
    <div className="o-aircraft-card">
      <div className="aircraft-card-body">
        <div className="aircraft-info-row">
          <div className="aircraft-icon">
            <img src={"/Resources/icons/" + icons[type] + ".svg"} />
          </div>
          <div className="aircraft-data">
            <h1>{props.mark}</h1>
            <ul>
              <li>
                <span className="fieldTitle">Kategori: </span>
                {aircraftCategoryTranslated(props.aircraftModelCategory)}
              </li>
              <li>
                <span className="fieldTitle">Type: </span>
                {aircraftCategoryTranslated(props.type)}
              </li>
              {props.manufacturer && props.manufacturer.length > 0 && (
                <li>
                  <span className="fieldTitle">Produsent: </span>
                  {props.manufacturer}
                </li>
              )}
              {((props.aircraftModelCategory === "Fly" && props.mtom > 15000) ||
                (props.aircraftModelCategory === "Helikopter" &&
                  props.mtom > 2000)) && (
                <li>
                  <span className="fieldTitle">Operatør: </span>
                  {props.operator}
                </li>
              )}
              {props.organizationalNumberOperator &&
              (<li>
                <span className="fieldTitle">Org.nr. operatør: </span>{" "}
                {props.organizationalNumberOperator}
              </li>)}
              <li>
                <span className="fieldTitle">Eier/kontakt: </span>{" "}
                {props.mainOwner}
              </li>
              {props.organizationalNumberOwnerContact &&
              (<li>
                <span className="fieldTitle">Org.nr. eier/kontakt:</span>{" "}
                {props.organizationalNumberOwnerContact}
              </li>)}
              <li>
                <span className="fieldTitle">Registreringsdato: </span>{" "}
                <Moment format="DD.MM.YYYY">{props.registrationDate}</Moment>
              </li>
            </ul>
          </div>
        </div>
        <div className="aircraft-data-row">
          <div className="column">
            <ul>
              <li>
                <span className="fieldTitle">Serienummer: </span>

                {props.aircraftSerialNumber}
              </li>
              <li>
                <span className="fieldTitle">Byggeår: </span>
                {props.aircraftConstructionYear > 0 ? props.aircraftConstructionYear : ''}
              </li>
              <li>
                <span className="fieldTitle">Startmasse MTOM: </span>
                {props.mtom} kg
              </li>
            </ul>
          </div>
          <div className="column">
            <ul>
              <li>
                <span className="fieldTitle">Luftdyktighetskategori: </span>

                {props.airworthinessCategory &&
                  Array.isArray(props.airworthinessCategory) &&
                  props.airworthinessCategory.join(", ")}
              </li>
              {props.aircraftICAOAddress && 
                <li>
                  <span className="fieldTitle">ICAO 24-bits adresse:</span>
                    <ul>
                      <li><span className="fieldTitle">Desimal: </span> {props.aircraftICAOAddress.decimal}</li>
                      <li><span className="fieldTitle">Binær: </span> {props.aircraftICAOAddress.binary}</li>
                      <li><span className="fieldTitle">Oktal: </span> {props.aircraftICAOAddress.octal}</li>
                      <li><span className="fieldTitle">Heksadesimal: </span> {props.aircraftICAOAddress.hexadecimal.toUpperCase()}</li>
                    </ul>
                </li>
              }
            </ul>
          </div>
        </div>
        <div className="aircraft-data-owners">
          <h2>{`Eierinformasjon (${props.owners.length})`}</h2>
          <div className="owner-list-header">EIER/KONTAKT</div>
          <div className="owner-list">
            {props.owners.map((owner, i) => {
              return (
                (expanded || i < 3) && (
                  <div className="owner" key={i}>
                    <ul>
                      {owner.ownerSince != null && (
                        <li>
                          <span className="fieldTitle">Eier fra: </span>
                          <Moment format="DD.MM.YYYY">
                            {owner.ownerSince}
                          </Moment>
                        </li>
                      )}
                      <li>
                        {owner.name}
                        <br />
                        {owner.organizationalNumber && (
                          <div>
                            <span>Org.nr.: </span>
                            {owner.organizationalNumber}
                            <br />
                          </div>
                        )}
                        {owner.street && (
                          <div>
                            {owner.street}
                            <br />
                          </div>
                        )}
                        {owner.zipCode} {owner.city}
                        <br />
                        {owner.country}
                      </li>
                    </ul>
                  </div>
                )
              );
            })}
          </div>
          {props.owners.length > 3 && (
            <div className={"show-all-owners" + (expanded ? " expanded" : "")}>
              <button
                onClick={(ev) => {
                  ev.preventDefault();
                  setExpanded(!expanded);
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  x="0px"
                  y="0px"
                  viewBox="0 0 18 30"
                  fill="#F06C00"
                >
                  <path
                    d="M17.01,13.58L4,0.56C3.21-0.2,1.96-0.19,1.18,0.59C0.41,1.36,0.4,2.61,1.16,3.4L12.76,15L1.16,26.6
	c-0.76,0.79-0.75,2.04,0.02,2.81C1.96,30.19,3.21,30.2,4,29.44l13.01-13.01c0.38-0.38,0.59-0.89,0.59-1.42
	C17.6,14.47,17.39,13.95,17.01,13.58z"
                  />
                </svg>

                {expanded ? "Vis færre" : "Vis alle"}
              </button>
            </div>
          )}
          <div className="back-to-search">
            <a href={listURL}>Tilbake til liste</a>
          </div>
        </div>
      </div>
    </div>
  );
};

const parseData = (dataNodeID) => {
  let data = {};

  try {
    const appData = document
      .getElementById(dataNodeID)
      .getAttribute("data-react-props");

    if (!appData) console.log(`${dataNodeID} node not found`);
    else {
      data = appData ? JSON.parse(appData) : {};
    }
  } catch (err) {
    console.error("parseData() fail", err);
  }

  return data;
};

const renderApp = () => {
  const appRootNode = document.getElementById("aircraft-card-root");
  if (!appRootNode) {
    console.warn(
      `Cannot find node with ID '${dataNodeID}'. The React app cannot be rendered.`
    );
    return;
  }

  const dataNodeID = "registration";
  let props = parseData(dataNodeID);

  ReactDOM.render(
    React.createElement(AircraftRegistrationCard, props),
    appRootNode
  );
};

const pad = (str, len) => {
  if (typeof str != "string") str = "" + str;
  while (str.length < len) str = "0" + str;
  return str;
};

renderApp();
